const auth = {
  u: 'api@philippejarrigeon.com',
  p: 'basicstuff'
}

export default auth
